import { render, staticRenderFns } from "./GameInfo.vue?vue&type=template&id=3e5596ec&"
import script from "./GameInfo.vue?vue&type=script&lang=js&"
export * from "./GameInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports